/* Sarvati free Diwali gift, 21 Oct 2026 (V.052).
   One product, "Free Diwali Gift" ($0, worth $119), goes into the bag by itself once the outfits and
   jewellery in it pass $499 at the prices shown (before the UTSAV discount), and leaves again when
   the bag drops under. Not a Shopify discount on purpose: the three UTSAV automatic discounts combine
   with nothing, so a Buy X get Y would either lose to the 35% or stack the tiers.

   Loaded once per page from snippets/sarvati-diwali-cart.liquid, which also prints window.SV_DW
   (the season state from snippets/sarvati-diwali-state.liquid: gift_on, gift_variant, gift_threshold
   in USD cents, gift_worth, the lines). Settings live in snippets/sarvati-diwali-config.liquid.

   WHEN IT LOOKS. After every cart change the theme makes: the theme's own cart:updated (quantity
   change in the drawer or cart page) and ajaxProduct:added (Add to cart), any request to
   /cart/add|change|update|clear seen by a PerformanceObserver (the same net sarvati-offer.js uses),
   the drawer's item list being rebuilt (MutationObserver, like sarvati-cart-merge.js), and a 1.5 s
   poll of /cart.js while the drawer is open or on the cart page. Every trigger is debounced 400 ms
   and never runs two checks at once.

   WHAT IT DOES. Reads /cart.js, adds up original_line_price of every line that is not the gift
   (the price before any discount), finds the gift line, then:
     over the line, no gift, not declined  -> POST /cart/add.js (quantity 1, property _gift)
     under the line, gift present          -> POST /cart/change.js quantity 0
     gift present with quantity above 1    -> back to 1
   and after its own request rebuilds the drawer list quietly (cart:build) and fires cart:updated,
   so the ladder and the add-on rows refresh as after any change; on the cart page it reloads, as
   the add-on row does. A 422 from /cart/add.js (sold out, unpublished) is swallowed: the progress
   line stays and nothing is retried on this page.

   HER CHOICE. If she takes the gift out herself while the bag is still over the line (the gift was
   there on this page, or it was added in this session for this same cart token and is now gone), the
   session remembers sv_dw_gift_declined (the cart token) and the gift is not added again for that
   cart. The decline is forgotten when the bag is emptied or the cart token changes (an order was
   placed, a new bag starts), so a fresh $499 bag in the same tab is offered the gift again.

   The progress line under the Diwali delivery box ([data-sv-dw-gift-progress]) is kept current:
   "Add $X more ..." with X in the cart's currency and the theme's money format, or "... is in your
   bag." with a tick. The gift line itself gets the worth struck through next to its $0 and its
   quantity control hidden (CSS keyed on the line key, which starts with the variant id).
   Thresholds for another currency follow the ladder's rule: USD cents times Shopify.currency.rate,
   rounded up to a whole unit. */
(function () {
  if (window.__svDwGift) return;
  window.__svDwGift = true;
  var S = window.SV_DW;
  if (!S || !S.on || !S.gift_on || !S.gift_variant) return;
  if (S.phase !== 'before' && S.phase !== 'after') return;

  var VID = parseInt(S.gift_variant, 10);
  var TH_USD = parseInt(S.gift_threshold, 10) || 49900;
  var WORTH_USD = (parseInt(String(S.gift_worth || '').replace(/[^\d]/g, ''), 10) || 119) * 100;
  var KEY_DECL = 'sv_dw_gift_declined', KEY_ADDED = 'sv_dw_gift_added';
  var timer = null, busy = false, queued = false, last = null, unavailable = false, fails = 0, poll = null;

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function iso(cart) { return (cart && cart.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; }
  function rate() { var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return r > 0 ? r : 1; }
  function local(usd, cart) { return iso(cart) === 'USD' ? usd : Math.ceil(usd * rate() / 100) * 100; }
  function money(c, cart) {
    var s = null;
    try { s = window.theme && theme.Currency && theme.Currency.formatMoney(Math.round(c), theme.settings.moneyFormat); } catch (e) { s = null; }
    if (!s) {
      try { s = new Intl.NumberFormat(undefined, { style: 'currency', currency: iso(cart) }).format(Math.round(c) / 100); } catch (e2) { s = (Math.round(c) / 100).toFixed(2) + ' ' + iso(cart); }
    }
    /* the shop's money format wraps the amount in <span class=money>; this goes into text, so the tags go */
    return String(s).replace(/<[^>]*>/g, '').trim();
  }
  function onCartPage() { return document.body.classList.contains('template-cart'); }
  function drawerOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(d && (d.classList.contains('drawer--is-open') || document.documentElement.classList.contains('js-drawer-open')));
  }

  function read(cart) {
    var sub = 0, gift = null;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === VID) { if (!gift) gift = it; return; }
      var lp = typeof it.original_line_price === 'number' ? it.original_line_price : it.line_price;
      sub += lp || 0;
    });
    return { sub: sub, gift: gift, th: local(TH_USD, cart) };
  }

  /* ---------- what she sees ---------- */
  function paint(st, cart, declined) {
    var has = !!st.gift, reached = st.sub >= st.th;
    document.querySelectorAll('[data-sv-dw-gift-progress]').forEach(function (b) {
      var before = b.querySelector('[data-sv-dw-gift-before]'), done = b.querySelector('[data-sv-dw-gift-done]');
      var state;
      if (has && reached) state = 'done';
      else if (!reached) state = 'before';
      else state = 'none'; /* over the line without the gift: she declined it, or it could not be added */
      b.setAttribute('data-sv-dw-gift-state', state);
      b.hidden = state === 'none';
      if (before) {
        before.hidden = state !== 'before';
        before.querySelectorAll('[data-sv-dw-gift-amount]').forEach(function (a) { a.textContent = money(st.th - st.sub, cart); });
      }
      if (done) done.hidden = state !== 'done';
    });
    decorate(cart);
  }
  function decorate(cart) {
    document.querySelectorAll('.cart__item[data-key^="' + VID + ':"]').forEach(function (el) {
      el.classList.add('sv-dw-gift-line');
      var col = el.querySelector('.cart__item-price-col');
      if (!col || col.querySelector('.sv-dw-gift-line__worth')) return;
      var w = document.createElement('small');
      w.className = 'cart__price cart__price--strikethrough sv-dw-gift-line__worth';
      w.textContent = money(local(WORTH_USD, cart), cart);
      col.insertBefore(w, col.firstChild);
    });
  }

  /* ---------- the cart ---------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }, function () { return { ok: r.ok, status: r.status, d: null }; }); });
  }
  function refreshTheme(cart) {
    if (onCartPage()) { window.scrollTo(0, 0); location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, svDwGift: true } }));
  }
  function add(cart) {
    return post('/cart/add.js', { id: VID, quantity: 1, properties: { _gift: 'Diwali 2026' } }).then(function (res) {
      if (!res.ok || !res.d || res.d.status === 422 || res.status === 422) { unavailable = true; fails++; return; }
      last = { has: true, sub: last ? last.sub : 0 };
      ss(KEY_ADDED, cart.token || '1');
      refreshTheme(cart);
    }, function () { fails++; });
  }
  function change(key, qty, cart) {
    return post('/cart/change.js', { id: key, quantity: qty }).then(function (res) {
      if (!res.ok || !res.d) { fails++; return; }
      if (qty === 0) { last = { has: false, sub: last ? last.sub : 0 }; ss(KEY_ADDED, null); }
      refreshTheme(cart);
    }, function () { fails++; });
  }

  function decide(cart) {
    var st = read(cart);
    var has = !!st.gift, reached = st.sub >= st.th;
    var tok = cart.token || '1';
    /* an empty bag forgets everything, so the next bag starts clean */
    if (!(cart.items && cart.items.length)) { ss(KEY_DECL, null); ss(KEY_ADDED, null); }
    /* a decline belongs to the cart it was made on; a new token (order placed) is a new bag */
    var declined = ss(KEY_DECL) === tok;
    /* she took it out herself: it was in the bag (on this page, or added this session for this same cart) and the bag is still over the line */
    if (!has && reached && !declined && ((last && last.has) || (ss(KEY_ADDED) && ss(KEY_ADDED) === tok))) {
      ss(KEY_DECL, tok); ss(KEY_ADDED, null); declined = true;
    }
    last = { has: has, sub: st.sub };
    paint(st, cart, declined);
    if (fails >= 3) return;
    if (reached && !has && !declined && !unavailable) return add(cart);
    if (!reached && has) return change(st.gift.key, 0, cart);
    if (has && st.gift.quantity > 1) return change(st.gift.key, 1, cart);
    if (has && reached) ss(KEY_ADDED, cart.token || '1');
  }

  function check() {
    if (busy) { queued = true; return; }
    busy = true;
    fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items) return decide(cart); })
      .catch(function () {})
      .then(function () { busy = false; if (queued) { queued = false; schedule(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 400); }

  /* ---------- triggers ---------- */
  function startPoll() {
    if (poll) return;
    poll = setInterval(function () {
      if (!drawerOpen() && !onCartPage()) { clearInterval(poll); poll = null; return; }
      if (!busy) check();
    }, 1500);
  }
  function start() {
    document.addEventListener('cart:updated', function (e) { if (!(e.detail && e.detail.svDwGift)) schedule(); });
    document.addEventListener('ajaxProduct:added', schedule);
    document.addEventListener('drawerOpen', function () { schedule(); startPoll(); });
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) { if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(e.name)) schedule(); });
        }).observe({ type: 'resource', buffered: false });
      } catch (e) {}
    }
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        var hit = false;
        for (var i = 0; i < muts.length && !hit; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && n.matches && (n.matches('.cart__item') || n.querySelector('.cart__item'))) { hit = true; break; }
          }
        }
        if (hit) { decorate(null); schedule(); }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (onCartPage() || drawerOpen()) startPoll();
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
